import { ApiRequestError } from '../lib/api.js';

/**
 * Fehlerseite. Nennt Ursache und den naechsten Schritt statt "Etwas ist
 * schiefgelaufen" — eine Meldung ohne Handlungsoption ist keine Meldung.
 */
export function ErrorPage({ error }: { error: unknown }) {
  const { title, detail, hint } = describe(error);

  return (
    <main className="auth-layout">
      <div className="card auth-card">
        <div className="card__body stack">
          <h1 style={{ fontSize: 'var(--text-xl)' }}>{title}</h1>
          <p className="muted text-sm">{detail}</p>
          {hint && <p className="text-sm">{hint}</p>}
          <button className="btn" data-variant="secondary" onClick={() => window.location.reload()}>
            Seite neu laden
          </button>
        </div>
      </div>
    </main>
  );
}

function describe(error: unknown): { title: string; detail: string; hint?: string } {
  if (error instanceof ApiRequestError) {
    if (error.status === 0) {
      return {
        title: 'Server nicht erreichbar',
        detail: error.message,
        hint: 'Laeuft die API? Im Entwicklungsbetrieb: pnpm --filter @mailflow/api dev',
      };
    }
    if (error.status === 403) {
      return {
        title: 'Keine Berechtigung',
        detail: error.message,
        hint: 'Ein Administrator kann die Rolle anpassen.',
      };
    }
    return { title: `Fehler ${error.status}`, detail: error.message };
  }

  return {
    title: 'Unerwarteter Fehler',
    detail: error instanceof Error ? error.message : 'Kein weiterer Hinweis verfuegbar.',
  };
}
